import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import record from './Modules.State.record';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    draftedLength: number = 0;
    draftedAmount: number = 0;
    draftedTax: number = 0;
    currentTab: string = '2';
    filterDisplay: boolean = false;
    selectInvoiceListData: any = [];
    confirmInvoiceListData: any = [];
    draftedInvoiceId: any = [];
    confirmRandom: number = 1;
    selectRandom: number = 2;
    recordRandom: number = 3;
    confirmPageNumber: number = 1;
    confirmPageSize: number = 20;
    confirmLoading: boolean = false;
    confirmHasMore: boolean = true;
    confirmTotal: number;
    confirmFields: any;
    comfirmFilter: any;
    selectPageNumber: number = 1;
    selectPageSize: number = 20;
    selectLoading: boolean = false;
    selectHasMore: boolean = true;
    selectTotal: number;
    selectFields: any = { authStates: ["UNCHECK"] };
    selectFilter: any = { authStates: ["UNCHECK"] };
    record = new record();
    authNoteDisplay: boolean = false;
    authType: number = 1;
    title: string = '';
    loggingFields: any;//一个是给组件赋值的对象，另一个是给接口使用的字符串对象.考虑时间组建，赋值使用对象，调用接口采用string。
    loggingFilter: any;
    loggingList: any = [];
    loggingPageSize: number = 20;
    loggingPageNum: number = 1;
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/Modules.State.ts